var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexes body-card-border-primary"},[_c('CircularMenu',{staticClass:"mt-5",on:{"menu-selected":_vm.handleMenuSelection}}),_c('transition',{attrs:{"name":"fade"}},[(_vm.selectedMenuItem)?_c(_vm.selectedMenuItem,{tag:"component",staticClass:"content"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }